var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.488,
    viewBox: "0 0 14.488 14.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{color:#000000;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-434.231 -457.832)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M473.869,489.046a5.952,5.952,0,1,0,1.744,4.212A5.958,5.958,0,0,0,473.869,489.046ZM470.3,497.19h-1.288v-5.329H470.3Zm0-6.576h-1.288v-1.288H470.3Z",
    transform: "translate(-28.182 -28.182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.595,459.956a7.238,7.238,0,1,0,2.124,5.12A7.25,7.25,0,0,0,446.595,459.956Zm-.91,9.33a5.952,5.952,0,1,1,1.746-4.21A5.966,5.966,0,0,1,445.685,469.286Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.288,
    height: 5.329,
    transform: "translate(440.831 463.679)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.288,
    height: 1.288,
    transform: "translate(440.831 461.144)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/info.icon.5ffdc9985ad3555ba264f1e1ea7ca903.svg";
export { ForwardRef as ReactComponent };